import {HStack, IconButton, Text} from '@chakra-ui/react';
import {useMaintenanceMessage} from 'ff-common';
import {useApi} from '@/haligator-factory';
import {WarningSignIcon} from '@/components/svg/WarningSignIcon';
import {CloseIcon} from '@/components/svg/CloseIcon';
import {useState} from 'react';

const STORAGE_KEY = 'maintenance-banner-dismissed';

export const MaintenanceBanner: React.FC = () => {
  const messageMaintenance = useMaintenanceMessage(useApi());
  const [isDismissed, setIsDismissed] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === 'true',
  );

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    setIsDismissed(true);
  };

  // Ne rien afficher si pas de message ou si fermé
  if (!messageMaintenance || isDismissed) {
    return null;
  }

  return (
    <HStack
      w='100%'
      bg='yellow.warning'
      px={{base: '16px', md: '24px'}}
      py='12px'
      alignItems='center'
      justifyContent='center'
      spacing={3}
    >
      <WarningSignIcon
        color='orange.warning'
        width='20px'
        height='20px'
      />
      <Text
        color='orange.warning'
        fontWeight={600}
        fontSize={{base: 'xs', md: 'sm'}}
        flex='1'
        textAlign='left'
        noOfLines={1}
      >
        {messageMaintenance}
      </Text>
      <IconButton
        aria-label='Fermer le bandeau'
        icon={
          <CloseIcon
            color='#CC8800'
            width='16px'
            height='16px'
          />
        }
        onClick={handleClose}
        variant='ghost'
        size='sm'
        minW='auto'
        h='auto'
        _hover={{bg: 'transparent', opacity: 0.7}}
      />
    </HStack>
  );
};
